import { Suspense } from 'react';
import { BrowserRouter, useLocation } from 'react-router-dom';
import { AppRoutes } from './router';
import { I18nextProvider } from 'react-i18next';
import i18n from './i18n';
import { AuthProvider } from './hooks/useAuth';
import { RouteLoadBoundary, RouteLoadingFallback } from './components/feature/RouteLoadBoundary';

function RouteContent() {
  const location = useLocation();
  return (
    <RouteLoadBoundary key={location.pathname}>
      <Suspense fallback={<RouteLoadingFallback />}>
        <AppRoutes />
      </Suspense>
    </RouteLoadBoundary>
  );
}

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <BrowserRouter basename={__BASE_PATH__}>
        <AuthProvider>
          <RouteContent />
        </AuthProvider>
      </BrowserRouter>
    </I18nextProvider>
  );
}

export default App;
